function toInt(value) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
}

function parseExternalProductData(item) {
    const raw = item?.external_product_data;
    if (!raw) return null;

    if (typeof raw === "object") {
        return raw;
    }

    if (typeof raw === "string") {
        try {
            return JSON.parse(raw);
        } catch (_) {
            return null;
        }
    }

    return null;
}

export function normalizeRoleId(roleId) {
    return toInt(roleId);
}

export function normalizeCommunityId(communityId) {
    if (
        communityId === null ||
        communityId === undefined ||
        communityId === "null" ||
        communityId === "undefined" ||
        communityId === ""
    ) {
        return null;
    }

    return toInt(communityId);
}

export function isAdminRole(roleId) {
    return normalizeRoleId(roleId) === 1;
}

export function hasCommunityScope(communityId) {
    return normalizeCommunityId(communityId) !== null;
}

export function extractOrderCommunityId(item) {
    const topLevelCommunityId = toInt(item?.community_id);
    if (topLevelCommunityId !== null) {
        return topLevelCommunityId;
    }

    const productCommunityId = toInt(item?.product_community?.community_id);
    if (productCommunityId !== null) {
        return productCommunityId;
    }

    const externalProductData = parseExternalProductData(item);
    const externalCommunityId = toInt(
        externalProductData?.external_data?.community_id ||
            externalProductData?.community_id,
    );

    return externalCommunityId;
}

export function filterOrdersByCommunity(items, communityId) {
    const normalizedCommunityId = normalizeCommunityId(communityId);
    if (normalizedCommunityId === null) {
        return items;
    }

    return items.filter(
        (item) => extractOrderCommunityId(item) === normalizedCommunityId,
    );
}

export function filterOrdersByRoleAndCommunity(items, roleId, communityId) {
    if (isAdminRole(roleId)) {
        return items;
    }

    if (!hasCommunityScope(communityId)) {
        return [];
    }

    return filterOrdersByCommunity(items, communityId);
}
